export default "__VITE_ASSET__32cad77a__"